import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getStitchingtaskStruct, setData } from './StitchingtaskStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './StitchingtaskAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updateStitchingtaskObj, addStitchingtaskObj, setShowEditForStitchingtask } from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import { use } from 'react';



export default function StitchingtaskEditFormImpl() {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getStitchingtaskStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const { mforder } = useSelector((state) => state.manufslice.mforderDashboard);
    const { mfproductorderObj } = useSelector((state) => state.manufslice.mfproductorderDashboard);
    const {product2skill2exp2rateList} = useSelector((state) => state.manufslice);
    const [selectedRateObj, setSelectedRateObj] = useState(null);
    const {stitchingtaskObj} = useSelector((state) => state.manufslice.stitchingtaskDashboard); 
    
    const {workerList} = useSelector((state)=>state.manufslice); 
    const [filteredWorkerList, setFilteredWorkerList] = useState([]);

    const { stitchingtaskDashboard } = useSelector((state) => state.manufslice);
    const [stitchingtaskId, setStitchingtaskId] = useState(stitchingtaskDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo);

    const { mfstitchingstatusList } = useSelector((state) => state.manufslice);
    const handleDynamicSelectedValueFortaskstatusid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'taskstatusname', e.target.value == 0 ? 'Select Item' : mfstitchingstatusList.find(obj => obj.id === e.target.value).title);
    }
    const { mfproductList } = useSelector((state) => state.manufslice);
    const handleDynamicSelectedValueForproductid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'productname', e.target.value == 0 ? 'Select Item' : mfproductList.find(obj => obj.id === e.target.value).title);
    }
    const handleDynamicSelectedValueForworkerid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'workername', e.target.value == 0 ? 'Select Item' : workerList.find(obj => obj.id === e.target.value).title);
    }

    const { apiInProgress } = useSelector((state) => state.headerslice)
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        console.log('selectedRateObj==>' + JSON.stringify(selectedRateObj));
    },[selectedRateObj]);

    useEffect(() => {
        let stitchingTaskStatusToDoObj = mfstitchingstatusList.find(obj => obj.title === 'TODO');
        console.log('stitchingTaskStatusToDoObj==>' + JSON.stringify(stitchingTaskStatusToDoObj));
        if (stitchingtaskId !== -1) {
            if (dataLoaded) return;
            getAPI(stitchingtaskId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            },
            ['orderid']: {
                ...formValues['orderid'],
                value: mfproductorderObj.orderid
            },
            ['productorderid']: {
                ...formValues['productorderid'],
                value: mfproductorderObj.id
            },
            ['productid']: {
                ...formValues['productid'],
                value: mfproductorderObj.productid
            },
            ['productname']: {
                ...formValues['productname'],
                value: mfproductorderObj.productname
            },
            ['taskstatusid']: {
                ...formValues['taskstatusid'],
                value: stitchingTaskStatusToDoObj.id
            },
            ['taskstatusname']: {
                ...formValues['taskstatusname'],
                value: stitchingTaskStatusToDoObj.title
            },
            ['stitchingrate']: {
                ...formValues['stitchingrate'],
                value: stitchingTaskStatusToDoObj.stitchingrate
            }

        })
        
        
    }, []);
    useEffect(() => {
         let workerIdsForSelectedProduct = product2skill2exp2rateList.filter(obj => obj.productid === mfproductorderObj.productid).map(obj => obj.workerid);
         console.log('workerIdsForSelectedProduct==>' + (workerIdsForSelectedProduct));
         console.log('workerList==>' + JSON.stringify(workerList));

        setFilteredWorkerList(
            workerList.filter(worker =>
                workerIdsForSelectedProduct.includes(worker.id)
            )
        );
    },[product2skill2exp2rateList]);

    useEffect(() => {
    if (formValues.workerid.value && formValues.assignedqty.value) {
        let rateObj = product2skill2exp2rateList.find(obj => obj.productid === mfproductorderObj.productid && obj.workerid === formValues.workerid.value);
        setSelectedRateObj(rateObj);
        let earning = rateObj && formValues.assignedqty.value!=''? formValues.stitchingrate.value * parseInt(formValues.assignedqty.value) : 0;
            setFormValues({
                ...formValues,
                ['earning']: {
                    ...formValues['earning'],
                    value: earning
                }
            })
    } else {
       // setSelectedRateObj(null);
    }
    },[formValues.assignedqty, formValues.workerid, formValues.stitchingrate]);

     useEffect(() => {
        if (stitchingtaskObj.workerid==formValues.workerid.value) return;
        if (formValues.workerid.value!== '' && formValues.workerid.value !== 0) {
        let rateObj = product2skill2exp2rateList.find(obj => obj.productid === mfproductorderObj.productid && obj.workerid === formValues.workerid.value);
            setSelectedRateObj(rateObj);
            setFormValues({
                ...formValues,
                ['stitchingrate']: {
                    ...formValues['stitchingrate'],
                    value: rateObj?rateObj.rate:0
                }
            })
        }
    
    },[formValues.workerid]);

    

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addStitchingtaskObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForStitchingtask(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateStitchingtaskObj(obj));
        setNotification('Record with id[' + stitchingtaskId + '] has been updated successfully !!!');
        dispatch(setShowEditForStitchingtask(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) => {
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id, formValues, updateSuccessCallback, failuerCallback) => {
        dispatch(setApiInProgress(true));
        updateAPI(id, formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit = (e) => {
        handleSubmit(e, stitchingtaskId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '58vh' }}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{stitchingtaskId === -1 ? 'Add' : 'Edit'} Stitching Task </Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                                    <Grid item lg={4} xs={7}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">{formValues.workerid.label}</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.workerid.label}
                                                name={formValues.workerid.name}
                                                value={formValues.workerid.value}
                                                onChange={handleDynamicSelectedValueForworkerid}

                                                error={formValues.workerid.error}
                                                helpertext={formValues.workerid.error && formValues.workerid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    filteredWorkerList && filteredWorkerList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item lg={1} xs={2}>
                                        <Typography variant="h6">@{selectedRateObj?selectedRateObj.rate:0}</Typography>
                                    </Grid>
                                    
                                    <Grid item lg={2} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.stitchingrate.placeholder}
                                            required={formValues.stitchingrate.required}
                                            label={formValues.stitchingrate.label}
                                            name={formValues.stitchingrate.name}
                                            value={formValues.stitchingrate.value}
                                            onChange={handleDoubleChange}
                                            error={formValues.stitchingrate.error}
                                            helperText={formValues.stitchingrate.error && formValues.stitchingrate.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                    <Grid item lg={3} xs={5}>
                                        <TextField size="Normal"
                                            placeholder={formValues.assignedqty.placeholder}
                                            required={formValues.assignedqty.required}
                                            label={formValues.assignedqty.label}
                                            name={formValues.assignedqty.name}
                                            value={formValues.assignedqty.value}
                                            onChange={handleTextChange}
                                            error={formValues.assignedqty.error}
                                            helperText={formValues.assignedqty.error && formValues.assignedqty.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                                                    <TextField size="Normal"
                                                                        placeholder={formValues.earning.placeholder}
                                                                        required={formValues.earning.required}
                                                                        label={formValues.earning.label}
                                                                        name={formValues.earning.name}
                                                                        value={formValues.earning.value}
                                                                        onChange={handleDoubleChange}
                                                                        error={formValues.earning.error}
                                                                        helperText={formValues.earning.error && formValues.earning.errorMessage}
                                                                        sx={{width:'100%'}}
                                                                    />
                                                                </Grid>
                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.title.placeholder}
                                            required={formValues.title.required}
                                            label={formValues.title.label}
                                            name={formValues.title.name}
                                            value={formValues.title.value}
                                            onChange={handleTextChange}
                                            error={formValues.title.error}
                                            helperText={formValues.title.error && formValues.title.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.receivedqty.placeholder}
                                            required={formValues.receivedqty.required}
                                            label={formValues.receivedqty.label}
                                            name={formValues.receivedqty.name}
                                            value={formValues.receivedqty.value}
                                            onChange={handleTextChange}
                                            error={formValues.receivedqty.error}
                                            helperText={formValues.receivedqty.error && formValues.receivedqty.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">{formValues.taskstatusid.label}</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.taskstatusid.label}
                                                name={formValues.taskstatusid.name}
                                                value={formValues.taskstatusid.value}
                                                onChange={handleDynamicSelectedValueFortaskstatusid}

                                                error={formValues.taskstatusid.error}
                                                helpertext={formValues.taskstatusid.error && formValues.taskstatusid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    mfstitchingstatusList && mfstitchingstatusList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.taskstatusname.placeholder}
                                            required={formValues.taskstatusname.required}
                                            label={formValues.taskstatusname.label}
                                            name={formValues.taskstatusname.name}
                                            value={formValues.taskstatusname.value}
                                            onChange={handleTextChange}
                                            error={formValues.taskstatusname.error}
                                            helperText={formValues.taskstatusname.error && formValues.taskstatusname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.orderid.placeholder}
                                            required={formValues.orderid.required}
                                            label={formValues.orderid.label}
                                            name={formValues.orderid.name}
                                            value={formValues.orderid.value}
                                            onChange={handleTextChange}
                                            error={formValues.orderid.error}
                                            helperText={formValues.orderid.error && formValues.orderid.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">{formValues.productid.label}</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.productid.label}
                                                name={formValues.productid.name}
                                                value={formValues.productid.value}
                                                onChange={handleDynamicSelectedValueForproductid}

                                                error={formValues.productid.error}
                                                helpertext={formValues.productid.error && formValues.productid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    mfproductList && mfproductList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.productorderid.placeholder}
                                            required={formValues.productorderid.required}
                                            label={formValues.productorderid.label}
                                            name={formValues.productorderid.name}
                                            value={formValues.productorderid.value}
                                            onChange={handleTextChange}
                                            error={formValues.productorderid.error}
                                            helperText={formValues.productorderid.error && formValues.productorderid.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>


                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.workername.placeholder}
                                            required={formValues.workername.required}
                                            label={formValues.workername.label}
                                            name={formValues.workername.name}
                                            value={formValues.workername.value}
                                            onChange={handleTextChange}
                                            error={formValues.workername.error}
                                            helperText={formValues.workername.error && formValues.workername.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', }}
                                        />
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{stitchingtaskId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForStitchingtask(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
        </form>
    );
};